module.exports = __webpack_public_path__ + "img/sld_acb_box.5faf4c79.svg";